module.exports = __webpack_public_path__ + "b6d147ff7467860dd03c99979b758052.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/owl_hoots/elf_owl_hoot.png
// module id = 2888
// module chunks = 0